exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home{width:100%;background-color:#fff}.home:after{content:\"\";display:block;height:1px}.home .content{display:block;margin:60px auto;color:#667;width:90%}@media screen and (min-width:970px){.home .content{width:520px}}@media screen and (min-width:1170px){.home .content{width:625px}}.home .content:before{content:\"\";display:block;height:1px}.home .content .title{text-align:center;margin:70px auto}.home .content .title h1{font-size:30px}.home .content article{line-height:30px}.home .content article p{margin-bottom:20px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./example/containers/Gallery.scss
 ** module id = 146
 ** module chunks = 0
 **/